

import React, { useState } from "react";
import { Link } from "react-router-dom";
import BookingForm from "./BookForm";
import img from "./assets/images/Flight_Booking_Logo.png";
import "./styles.css"; // Bootstrap is already included in your project

export default function Navbar() {
  const [showEnquiry, setShowEnquiry] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const handleClose = () => {
    setShowEnquiry(false);
    setFormSubmitted(false);
  };

  return (
    <>
      {/* Fixed navbar */}
      <nav className="navbar navbar-expand-lg navbar-light bg-white shadow-sm px-4 fixed-top">
        <div className="container-fluid">
          <Link className="navbar-brand" to="/">
            <img src={img} alt="FlightBook Logo" className="d-inline-block align-top" style={{ height: "60px" }} />
          </Link>

          {/* Mobile Toggle Button */}
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? <span>✖</span> : <span className="navbar-toggler-icon"></span>}
          </button>

          {/* Navbar Links */}
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav ms-auto">
              <li className="nav-item">
                <Link className="nav-link" to="/">
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/about">
                  About Us
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/contact">
                  Contact Us
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/privacy">
                  Privacy policy
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/refund">
                  Refund policy
                </Link>
              </li>
            </ul>

            {/* Enquiry Button */}
            <button className="btn btn-danger ms-3" onClick={() => setShowEnquiry(true)}>
              Enquiry Now
            </button>
          </div>
        </div>
      </nav>

      {/* Add margin so content doesn't overlap */}
      <div style={{ marginTop: "7px" }}>
        {/* Your page content here */}
      </div>

      {/* Enquiry Form Popup */}
      {showEnquiry && (
        <div className="modal-overlay" onClick={handleClose}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            {formSubmitted ? (
              <div className="success-message">
                <h4>Form submitted successfully!</h4>
                <button className="btn btn-success mt-2" onClick={handleClose}>
                  Close
                </button>
              </div>
            ) : (
              <>
                <button className="close-button" onClick={handleClose}>
                  ×
                </button>
                <BookingForm onClose={handleClose} onSubmit={() => setFormSubmitted(true)} />
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
}
